import React, { useState, useEffect } from 'react';
import './Gallery.css';
import { ZoomIn, X, ChevronLeft, ChevronRight, Image as ImageIcon } from 'lucide-react';

const Gallery = () => {
    const [activeTab, setActiveTab] = useState('field');
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [filteredImages, setFilteredImages] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Full Image Dataset
    const allImages = [
        // Lap & resources Gallery
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688747/DSC00909_jjryvs.jpg',
            category: 'lab',
            title: 'Research & Resources'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688744/DSC00910_pskf7v.jpg',
            category: 'lab',
            title: 'Scientific Analysis'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688737/PHOTO-2026-03-02-09-50-14_2_fkuot0.jpg',
            category: 'lab',
            title: 'Lab Observation'
        },

        // Industries Gallery
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688736/PHOTO-2026-03-02-10-13-40_qydox8.jpg',
            category: 'industries',
            title: 'Industrial Processing'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688736/PHOTO-2026-03-02-10-06-53_b9g29r.jpg',
            category: 'industries',
            title: 'Extraction Unit'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688736/PHOTO-2026-03-02-10-13-10_lg3pdo.jpg',
            category: 'industries',
            title: 'Quality Control'
        },

        // Field & Farms Gallery
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1776845309/MACADAMIA_j2acak.png',
            category: 'field',
            title: 'Exotic Fruits Crop'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688736/PHOTO-2026-03-02-10-12-14_v7qxqm.jpg',
            category: 'field',
            title: 'Field Crops Integration'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688736/PHOTO-2026-03-02-10-08-57_phejcz.jpg',
            category: 'field',
            title: 'Farm View'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1776848100/COCONUT_DROP_ybguvw.jpg',
            category: 'field',
            title: 'Coconut Drop'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688735/PHOTO-2026-03-02-10-08-56_k7mwpv.jpg',
            category: 'field',
            title: 'Agriculture Fields'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688735/PHOTO-2026-03-02-10-05-25_2_efslyg.jpg',
            category: 'field',
            title: 'Plantation Overview'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688733/PHOTO-2026-03-02-09-52-47_2_juyti7.jpg',
            category: 'field',
            title: 'Medicinal & Aromatic Plants'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1776847417/White_sandalwood_pdzcor.png',
            category: 'field',
            title: 'White Sandalwood'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688734/PHOTO-2026-03-02-09-52-47_hpeo1z.jpg',
            category: 'field',
            title: 'Sustainable Growth'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688734/PHOTO-2026-03-02-09-54-49_xfzxpe.jpg',
            category: 'field',
            title: 'Crops Harvesting'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688734/PHOTO-2026-03-02-09-52-47_3_swhl1o.jpg',
            category: 'field',
            title: 'Organic Farming'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688733/PHOTO-2026-03-02-09-50-15_rouznn.jpg',
            category: 'field',
            title: 'Lush Fields'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688733/PHOTO-2026-03-02-09-52-46_3_quhd4r.jpg',
            category: 'field',
            title: 'Aromatic Crops'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688733/PHOTO-2026-03-02-09-52-46_2_eoyybl.jpg',
            category: 'field',
            title: 'Herb Cultivation'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688732/PHOTO-2026-03-02-10-05-25_4_flb6zr.jpg',
            category: 'field',
            title: 'Forestry Wood Brandings'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688732/PHOTO-2026-03-02-09-55-15_jyrhg1.jpg',
            category: 'field',
            title: 'Field Consultation'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688732/PHOTO-2026-03-02-09-50-14_lq31t9.jpg',
            category: 'field',
            title: 'Farmers Working'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688731/PHOTO-2026-03-02-09-50-14_2_1_cixx3e.jpg',
            category: 'field',
            title: 'Green Expanse'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1772688747/DSC00909_jjryvs.jpg',
            category: 'field',
            title: 'Farmers Working'
        },
        {
            src: 'https://res.cloudinary.com/dexueorjm/image/upload/v1776847846/Shatavari_roots_ktmxpw.png',
            category: 'field',
            title: 'Shatavari roots'
        }
    ];

    // Filter Effect
    useEffect(() => {
        if (activeTab === 'all') {
            setFilteredImages(allImages);
        } else {
            setFilteredImages(allImages.filter(img => img.category === activeTab));
        }
    }, [activeTab]);

    const openLightbox = (index) => {
        setCurrentImageIndex(index);
        setLightboxOpen(true);
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
        document.body.style.overflow = 'unset';
    };

    const nextImage = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prev) => (prev + 1) % filteredImages.length);
    };

    const prevImage = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prev) => (prev - 1 + filteredImages.length) % filteredImages.length);
    };

    const categories = [
        { id: 'all', label: 'All Photos' },
        { id: 'lab', label: 'Lap & resources' },
        { id: 'industries', label: 'Industries' },
        { id: 'field', label: 'Field & Farms' }
    ];

    return (
        <div className="gl-premium-page">

            {/* Gallery Hero */}
            <div className="gl-hero">
                <div className="gl-hero-content">
                    <h1 className="gl-title">Our Gallery</h1>
                    <p className="gl-subtitle">A visual journey through our innovations, fields, and facilities.</p>
                </div>
            </div>

            <div className="gl-container">

                {/* Tabs */}
                <div className="gl-tabs">
                    {categories.map(cat => (
                        <button
                            key={cat.id}
                            className={`gl-tab-btn ${activeTab === cat.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(cat.id)}
                        >
                            {cat.label}
                        </button>
                    ))}
                </div>

                {/* Grid */}
                <div className="gl-grid">
                    {filteredImages.map((image, index) => (
                        <div key={index} className="gl-grid-item" onClick={() => openLightbox(index)}>
                            <div className="gl-image-wrapper">
                                <img src={image.src} alt={image.title} className="gl-image" loading="lazy" />
                                <div className="gl-overlay">
                                    <ZoomIn className="gl-zoom-icon" size={30} />
                                    <span className="gl-img-title">{image.title}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {filteredImages.length === 0 && (
                    <div className="gl-empty-state">
                        <ImageIcon size={48} className="gl-empty-icon" />
                        <p>No images found in this category.</p>
                    </div>
                )}

                <div className="gl-footer-tag">Emerging Farmers Empowerment</div>

            </div>

            {/* Lightbox Modal */}
            {lightboxOpen && (
                <div className="gl-lightbox-overlay" onClick={closeLightbox}>
                    <div className="gl-lightbox-content">
                        <button className="gl-close-btn" onClick={closeLightbox}>
                            <X size={32} />
                        </button>

                        <button className="gl-nav-btn prev" onClick={prevImage}>
                            <ChevronLeft size={40} />
                        </button>

                        <div className="gl-lightbox-image-container" onClick={(e) => e.stopPropagation()}>
                            <img
                                src={filteredImages[currentImageIndex].src}
                                alt="Fullscreen"
                                className="gl-lightbox-img"
                            />
                            <div className="gl-caption">
                                {filteredImages[currentImageIndex].title}
                            </div>
                        </div>

                        <button className="gl-nav-btn next" onClick={nextImage}>
                            <ChevronRight size={40} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Gallery;
